export const globalGetters = {
  states: 'state/states'
}

export const getters = {
  states: state => state.states
}
